import Auth0Impl from './auth0-impl';
import Auth0Mock from './auto0-impl.mockapi';

const auth0 = Auth0Mock?.initialize ? Auth0Mock : Auth0Impl;
export default auth0;
